<template>
    <span v-if="status === CourseApplicationStatus.Accepted" class="text-green-600">ACCEPTED</span>
    <span v-else-if="status === CourseApplicationStatus.Rejected" class="text-red-600">REJECTED</span>
    <span v-else-if="status === CourseApplicationStatus.Cancelled" class="text-gray-600">CANCELLED</span>
    <span v-else>PENDING</span>
</template>

<script>

import {CourseApplicationStatus} from "@/Lib/Enums";

export default {
    props: {
        status: Number
    },
    data() {
        return {
            CourseApplicationStatus
        }
    },
}
</script>
